<script lang="ts" setup>
  import { usePermission } from '@vueuse/core'
  import { computed, ref } from 'vue'
  import { usePwa } from '@/composables/usePwa'

  const pwa = usePwa()
  const notifPermission = usePermission('notifications')
  const pushPermission = ref<boolean>()

  const clicked = ref(false)

  const toast = useToastSimplified()

  const showBanner = computed(() => {
    const notif = notifPermission.value
    const push = pushPermission.value

    return !clicked.value && (notif === 'prompt' || (notif === 'granted' && push === false))
  })

  const requestPushPermission = async () => {
    clicked.value = true

    if (notifPermission.value !== 'granted') {
      const result = await Notification.requestPermission()
      if (result !== 'granted') {
        toast.add({
          severity: 'warn',
          life: 2500,
          summary: 'Benachrichtigungen wurden abgelehnt.'
        })
        return
      }
    }

    try {
      await pwa.registerPush()
      toast.add({
        severity: 'success',
        life: 2500,
        summary: 'Push-Benachrichtigungen erfolgreich aktiviert!'
      })
    } catch (err) {
      console.warn('[PWA-Push] Fehler bei Registrierung:', err)
      toast.add({
        severity: 'warn',
        life: 2500,
        summary: 'Registrierung für Push-Benachrichtigungen fehlgeschlagen.'
      })
    }
  }

  onMounted(async () => {
    const registration = await navigator.serviceWorker.ready

    if ('pushManager' in registration) {
      const subscription = await registration.pushManager.getSubscription()
      pushPermission.value = !!subscription
    } else {
      pushPermission.value = false // oder null / 'unsupported'
    }
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      console.warn('Push API wird vom Browser nicht unterstützt.')
    }

    // whenTitropReady(() => {
    //   enableBanner.value = useTitrop().value.config.app('enable_push_notifications', false).value ?? false
    // })
  })
</script>

<template>
  <div
    v-if="false"
    class="bg-indigo-800 hover:bg-indigo-600 text-center pb-2 mx-auto py-1 sm:py-2 px-2 sm:px-4 items-center text-indigo-100 w-full leading-2 cursor-pointer"
    role="alert"
    @click="requestPushPermission">
    <span>Wir werden bald Push-Benachrichtigungen unterstützen. Hierfür benötigen wir aber eine explizite Erlaubnis – einfach hier klicken und auswählen.</span>
    <span v-if="$titrop.DEV">(Noti: {{ notifPermission }}, Push: {{ pushPermission }}, ShowBanner: {{ showBanner }})</span>
  </div>
</template>
